// extracted by mini-css-extract-plugin
export default {"control":"kKpyD","root":"_5SF9p","webinarMessage":"+QleE","noDevices":"_7vIGl","link":"aOKZf"};